import { render, staticRenderFns } from "./matrix-tabs.vue?vue&type=template&id=57dca696&scoped=true"
import script from "./matrix-tabs.vue?vue&type=script&lang=js"
export * from "./matrix-tabs.vue?vue&type=script&lang=js"
import style0 from "./matrix-tabs.vue?vue&type=style&index=0&id=57dca696&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dca696",
  null
  
)

export default component.exports